const routes = {
  Home: '/',

  XpayRedirect: '/xpay-redirect',

  WhatIsLynks: '/what-is-lynks',
  ElectronicsWithLynks: '/electronics-with-lynks',
  FashionWithLynks: '/fashion-with-lynks',
  LynksExport: '/export',
  ComeBack: '/come-back',
  LynksShield: '/shield',
  FindTheLink: '/find-the-link-game',
  FindTheLinkClaim: '/find-the-link-game/claim',
  Store: '/s/:id',
  // StoreRedirect: '/s/:id/redirect',
  StoreRedirect: '/visit-store',

  Browse: '/browse/:id',
  Cart: '/cart',
  Tracking: '/tracking',
  TrackingShow: '/tracking/:id',
  OrdersHistory: '/account/orders-history',
  OrdersHistoryShow: '/account/orders-history/:id',

  Contact: '/contact',
  Account: '/account',
  AccountProfile: '/account/profile',
  AccountSubscription: '/account/subscriptions',
  AccountAddressBook: '/account/address-book',
  AccountWallet: '/account/wallet',
  AccountLegacyOrders: '/account/orders-history',
  AccountPasswordReset: '/account/password-reset/:token',

  CartEdit: '/orders-history/:id',

  Login: '/login',
  Register: '/register',
  ForgetPassword: '/reset-password',
  ChooseCountry: '/choose-country',

  Shop: 'https://shop.lynks.com/',
  Blackfriday: '/black-friday',
  CyberMonday: '/cyber-monday',
  EndOfYear: '/new-year-sale',
  ExclusiveOffers: '/exclusive-offers',
  Business: '/business-plans',
  Pricing: '/pricing',
  Faq: '/faq',
  Stores: '/stores',
  TermsAndConditions: '/terms-and-conditions',
  PrivacyPolicy: '/privacy-policy',
  ProhibitedItems: '/prohibited-items',
  LynksVsEdfa3ly: '/lynks-vs-edfa3ly',
  HowItWorks: '/how-it-works',

  LiteCheckout: '/checkout',
  Checkout: '/checkout/:type/:id',
  typeOnlyCheckout: '/checkout/:type/',
  ThankYou: '/checkout/:type/thank_you',

  HealthCheck: '/health_check',
  Promotions: '/promotions',
  PromotionPage: '/promotions/:id',

  CashbackPage: '/cashback',
};

export default routes;



// WEBPACK FOOTER //
// ./app/config/routes.js